import CommonHeader from '../../../Components/Headers/CommonHeader';
import Login from '../Login';
import LoginSso from './LoginSso';

type LoginPageProps = { isSso?: boolean };

export default function LoginPage({ isSso = false }: LoginPageProps) {
  return (
    <>
      <CommonHeader />
      <div>{isSso ? <LoginSso /> : <Login />}</div>
    </>
  );
}
